import { useState, useEffect } from 'react';

// sessionStorage: shows once per browser session, reappears on new tab/visit.
const STORAGE_KEY = 'reload_popup_dismissed';
const KLAVIYO_URL = 'https://a.klaviyo.com/client/subscriptions';
const PUBLIC_KEY = process.env.REACT_APP_KLAVIYO_PUBLIC_KEY;
const LIST_ID = process.env.REACT_APP_KLAVIYO_LIST_ID;

export function useEmailPopup() {
  const [visible, setVisible] = useState(false);
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle | loading | success | error
  const [errorMsg, setErrorMsg] = useState('');

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (sessionStorage.getItem(STORAGE_KEY)) return;
    const timer = setTimeout(() => setVisible(true), 3000);
    return () => clearTimeout(timer);
  }, []);

  const dismiss = () => {
    sessionStorage.setItem(STORAGE_KEY, '1');
    setVisible(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setStatus('loading');
    setErrorMsg('');

    const body = JSON.stringify({
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'RELOAD Website Popup',
          profile: {
            data: {
              type: 'profile',
              attributes: { email },
            },
          },
        },
        relationships: {
          list: { data: { type: 'list', id: LIST_ID } },
        },
      },
    });

    const xhr = new XMLHttpRequest();
    xhr.open('POST', `${KLAVIYO_URL}?company_id=${PUBLIC_KEY}`);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.setRequestHeader('revision', '2023-12-15');

    xhr.onload = () => {
      if (xhr.status === 200 || xhr.status === 202) {
        setStatus('success');
        sessionStorage.setItem(STORAGE_KEY, '1');
      } else {
        setStatus('error');
        setErrorMsg('Something went wrong. Please try again.');
      }
    };

    xhr.onerror = () => {
      setStatus('error');
      setErrorMsg('Network error. Please try again.');
    };

    xhr.send(body);
  };

  return { visible, email, setEmail, status, errorMsg, dismiss, handleSubmit };
}
